document.addEventListener("DOMContentLoaded", () => {
  const detailsButtons = document.querySelectorAll(".details-button");
  const dialogs = document.querySelectorAll(".details-dialog");
  const closeButtons = document.querySelectorAll(".dialog-close");

  const closeAllDialogs = () => {
    dialogs.forEach((dialog) => {
      dialog.style.display = "none";
      dialog.classList.remove("active");
    });
    document.body.classList.remove("dialog-open");
  };

  // Function to open a specific dialog
  const openDialog = (dialog) => {
    closeAllDialogs();
    dialog.style.display = "block";
    dialog.classList.add("active");
    document.body.classList.add("dialog-open");

    // Focus on the search input in this dialog
    const searchInput = dialog.querySelector(".details-dialog__search input");
    if (searchInput) {
      // Use setTimeout to ensure the dialog is fully rendered before focusing
      setTimeout(() => {
        searchInput.focus();
      }, 50);
    }
  };

  // Open dialog when details button is clicked
  detailsButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      const dialogWrapper = button.closest(".dialog-wrapper");
      dialog = dialogWrapper.querySelector(".details-dialog");
      openDialog(dialog);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      closeAllDialogs();
    });
  });

  dialogs.forEach((dialog) => {
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) {
        closeAllDialogs();
      }
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeAllDialogs();
    }
  });
});
